import type * as React from 'react'
import { useCallback } from 'react'

import NotificationContainer from './NotificationContainer'
import { NotificationScopes } from '../AppConstants'
import A from './shared/A'
import Button from './shared/Button'
import NotificationActionCreators from '../action-creators/NotificationActionCreators'
import type { Notification } from '../values/Notification'

import styles from './css/ProductRolloutTooltip.module.css'

interface ProductRolloutTooltipProps {
  visibleNotifications: Notification[]
  isOmniboxEnabled: boolean
}

const ProductRolloutTooltip = ({
  visibleNotifications,
  isOmniboxEnabled,
}: ProductRolloutTooltipProps): JSX.Element => {
  // Prevent side-effects on composers' expanded state when clicking in the tooltip
  const onTooltipClick = useCallback(
    (e: React.MouseEvent<HTMLElement>): void => {
      e.stopPropagation()
    },
    [],
  )

  const onButtonClick = useCallback(
    (e: React.MouseEvent<HTMLElement>): void => {
      e.stopPropagation()

      // There's only supposed to be one such notification at all times
      const productRolloutNotification = visibleNotifications.find(
        (notif) => notif.scope === NotificationScopes.MC_ROLLOUT_INFO,
      )

      if (productRolloutNotification) {
        NotificationActionCreators.removeNotification(
          productRolloutNotification.id,
        )
      }
    },
    [visibleNotifications],
  )

  const notificationContainerClassNames = {
    container: isOmniboxEnabled
      ? styles.bottomPositionedContained
      : styles.container,
    notification: styles.tooltip,
  }

  return (
    <NotificationContainer
      visibleNotifications={visibleNotifications}
      classNames={notificationContainerClassNames}
      scope={NotificationScopes.MC_ROLLOUT_INFO}
      onClick={onTooltipClick}
    >
      <Button className={styles.button} onClick={onButtonClick}>
        Awesome, got it!
      </Button>
      <A href="/new-buffer-composer" target="_blank" rel="noopener noreferrer">
        Learn More
      </A>
    </NotificationContainer>
  )
}

export default ProductRolloutTooltip
